import React, { useState, useEffect } from 'react';
import api from '../services/api';

function errorMessage(err) {
  if (err.status === 404) return 'Không tìm thấy bài làm';
  if (err.status === 403) return 'Bạn không có quyền xem bài làm này';
  return err.message || 'Đã có lỗi xảy ra';
}

function AssessmentSubmissionDetail({ submissionId }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    api.getAssessmentSubmission(submissionId)
      .then((data) => {
        if (active) setDetail(data);
      })
      .catch((err) => {
        if (active) setError(errorMessage(err));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [submissionId]);

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="error-message">{error}</div>;
  if (!detail) return null;

  const answers = detail.answers || [];

  return (
    <div className="submission-detail">
      <div className="submission-detail-meta">
        <p><strong>Đối tượng:</strong> {detail.subject_full_name || detail.subject_username}</p>
        <p><strong>Bài đánh giá:</strong> {detail.assessment_name} ({detail.assessment_code})</p>
        <p><strong>Người thực hiện:</strong> {detail.administered_by_username || '-'}</p>
        <p><strong>Hoàn thành:</strong> {detail.is_complete ? 'Có' : 'Chưa'}</p>
        <p><strong>Nộp lúc:</strong> {detail.submitted_at ? new Date(detail.submitted_at).toLocaleString() : '-'}</p>
        {detail.note && <p><strong>Ghi chú:</strong> {detail.note}</p>}
      </div>

      <div className="score-summary">
        <div className="total-score-box">
          <span className="total-score-label">Tổng điểm</span>
          <span className="total-score-value">{detail.total_score}</span>
        </div>

        {detail.subscale_scores && detail.subscale_scores.length > 0 && (
          <table className="table subscale-table">
            <thead>
              <tr>
                <th>Tiểu thang</th>
                <th>Điểm</th>
                <th>Số câu đã trả lời</th>
              </tr>
            </thead>
            <tbody>
              {detail.subscale_scores.map((s) => (
                <tr key={s.subscale_code || 'default'}>
                  <td>{s.subscale_code || '-'}</td>
                  <td>{s.raw_score}</td>
                  <td>{s.answered_questions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {answers.length === 0 ? (
        <p>Chưa có câu trả lời nào.</p>
      ) : (
        <ol className="question-list">
          {answers.map((answer) => (
            <li key={answer.id} className="question-item">
              <div className="question-text">
                {answer.question_number != null ? `${answer.question_number}. ` : ''}
                {answer.question_text}
                {answer.subscale_code && (
                  <span className="subscale-badge">{answer.subscale_code}</span>
                )}
              </div>
              <div className="answer-value">
                {answer.option_text}
                {answer.option_score != null && ` — ${answer.option_score} điểm`}
              </div>
              {answer.specialist_score != null && (
                <div className="specialist-note">
                  Ghi chú chuyên viên: {answer.specialist_note || '-'} — điểm riêng: {answer.specialist_score}
                  <span className="specialist-note-hint"> (điểm này không cộng vào tổng điểm)</span>
                </div>
              )}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}

export default AssessmentSubmissionDetail;
